export default "/server-build/img/e86e1b35edbd8aea39a42d12bfe3638e.png";